import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
//import IconLogin from '../icons/IconLogin'

class Navegacion extends Component{
    render() {
        return (
            <nav>
                <ul>
                    <li>
                        <NavLink exact activeClassName="current" to={'/'} rel="preload">Inicio</NavLink>
                    </li>
                    <li>
                        <NavLink exact activeClassName="current" to={'/nosotros'} rel="preload">Nosotros</NavLink>
                    </li>
                    <li>
                        <NavLink exact activeClassName="current" to={'/dormitorios'} rel="preload">Dormitorios</NavLink>
                    </li>
                    <li>
                        <NavLink exact activeClassName="current" to={'/contacto'} rel="preload">Contacto</NavLink>
                    </li>
                </ul>
                {/* 
                <NavLink exact activeClassName="current" to={'/login'} className="btnLogin f f-ac f-jc">
                    <IconLogin />
                    <span>Entrar</span>
                </NavLink>
                */}
            </nav>
        )
    }
}

export default Navegacion